import styled from "styled-components";

const ExperienceDiv = styled.section`
  width: 100%;
  background-color: #0f172a;
  color: #ffffff;
  padding: 50px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  font-family: inherit;

  .title {
    font-size: 35px;
    font-weight: 500;
    margin: 0;
  }

  .experienceList {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    position: relative;
  }

  .experienceCard {
    background-color: #111827;
    border-radius: 10px;
    padding: 25px 30px;
    box-shadow: 0 15px 35px rgba(15, 23, 42, 0.35);
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #1e293b;
    font-family: inherit;
    position: relative;
    overflow: visible;
  }

  .experienceFlow {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    transform: translateX(-50%);
    width: 4px;
    background: linear-gradient(180deg, rgba(56, 189, 248, 0.3), rgba(56, 189, 248, 0));
    pointer-events: none;
  }

  .experienceFlowArrow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 12px solid rgba(56, 189, 248, 0.8);
    filter: drop-shadow(0 6px 6px rgba(15, 23, 42, 0.35));
    pointer-events: none;
  }

  .experienceFlowConnector {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 11px solid rgba(56, 189, 248, 0.7);
    filter: drop-shadow(0 6px 6px rgba(15, 23, 42, 0.35));
  }

  .experienceCard + .experienceCard {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: -14px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-top: 11px solid rgba(56, 189, 248, 0.7);
      filter: drop-shadow(0 6px 6px rgba(15, 23, 42, 0.35));
    }
  }

  .experienceHeader {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 15px;

    h3 {
      font-size: 24px;
      margin: 0;
      font-family: inherit;
    }

    .tagline {
      margin: 5px 0 0;
      color: #38bdf8;
      font-size: 15px;
      font-weight: 500;
      font-family: inherit;
    }

    .meta {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
      font-size: 14px;
      text-align: right;
      color: #cbd5f5;
      font-family: inherit;

      p {
        margin: 0;
        font-family: inherit;
      }
    }
  }

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    list-style: none;

    li {
      position: relative;
      padding-left: 22px;
      line-height: 1.5;
      font-size: 15px;
      color: #e2e8f0;
      text-align: left;
      font-family: inherit;

      &::before {
        content: "";
        position: absolute;
        left: 6px;
        top: 10px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #38bdf8;
      }
    }
  }

  @media (max-width: 768px) {
    .experienceList {
      width: 90%;
    }

    .experienceFlow,
    .experienceFlowArrow,
    .experienceFlowConnector {
      display: none;
    }

    .experienceCard + .experienceCard {
        &::before {
          left: 40px;
      }
    }
  }

  @media (max-width: 900px) {
    .experienceList {
      width: 90%;
    }

    .experienceCard {
      padding: 22px;
    }

    .experienceHeader {
      .meta {
        align-items: flex-start;
        text-align: left;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 40px 0;

    .experienceList {
      width: calc(100% - 40px);
    }

    .experienceCard {
      padding: 20px;
    }

    .experienceHeader {
      h3 {
        font-size: 20px;
      }

      .tagline {
        font-size: 14px;
      }

      .meta {
        font-size: 13px;
      }
    }

    ul {
      li {
        padding-left: 20px;
        font-size: 14px;
        font-family: inherit;

        &::before {
          left: 4px;
        }
      }
    }
  }
`;

export default ExperienceDiv;
